import { useRef, useEffect } from 'react';
import { Box, Button, Hidden } from '@mui/material';
import { useScreenWidth } from 'webHooks/useScreenWidth';
import { useInViewport } from 'webHooks/useInViewport';
import ClearIcon from '@mui/icons-material/Clear';
import styled from 'styled-components';

interface Props {
  loadMoreDatesDisabled: boolean;
  showNextMonth: () => void;
  onTodayClick: () => void;
  clearDates: () => void;
}

export const StyledFooter = styled(Box)`
  padding: ${props => props.theme.spacing(2)};  
  background-color: ${props => props.theme.palette.grey[50]};
  border-top: 1px solid ${props => props.theme.palette.grey[300]};

  & button {
    background-color: #fff;
  }
`;

export const CheckoutDateRangePickerFooter = ({
  loadMoreDatesDisabled,
  showNextMonth,
  onTodayClick,
  clearDates,
}: Props) => {
  const { isXs } = useScreenWidth();
  const ref = useRef<HTMLButtonElement>(null);
  const isInViewport = useInViewport(ref);

  useEffect(() => {
    if (!isXs || !isInViewport) return;
    ref.current?.click();
  }, [isInViewport, isXs]);

  if (isXs) {
    return (
      <Box sx={{ mx: 2, mt: 1, mb: 3, opacity: 0, }}>
        <Button
          ref={ref}
          color="secondary"
          variant="outlined"
          fullWidth
          disabled={loadMoreDatesDisabled}
          onClick={() => {
            showNextMonth();
          }}
        >
          {loadMoreDatesDisabled ? 'No More Dates to Load' : 'Show More Dates'}
        </Button>
      </Box>
    );
  }

  return (
    <StyledFooter>
      <Hidden xsUp>
        <Button color="secondary" onClick={onTodayClick}>
          Today
        </Button>
      </Hidden>
      <Button color="secondary" variant="outlined" onClick={clearDates} fullWidth startIcon={<ClearIcon color="error" />}>
        Clear Dates (Start Again)
      </Button>
    </StyledFooter>
  );
};
